module.exports = __webpack_public_path__ + "static/media/121.6a89b283.png";